// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"a8fee50c","266":"d690058d"}[chunkId] + ".chunk.js";
};